export const docMask = (v: string) => {
  if (!v) return ''

  if (/^\d+$/.test(v)) {
    v = v.replace(/\D/g, '')

    if (v.length <= 11) {
      v = v.replace(/(\d{3})(\d)/, '$1.$2')
      v = v.replace(/(\d{3})(\d)/, '$1.$2')
      v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2')
    } else {
      v = v.replace(/^(\d{2})(\d)/, '$1.$2')
      v = v.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      v = v.replace(/\.(\d{3})(\d)/, '.$1/$2')
      v = v.replace(/(\d{4})(\d)/, '$1-$2')
    }
  } else {
    v = v.replace(/[^\w\s]/gi, '')
  }
  return v
}

export const formatTaxid = (taxid: string): string => {
  return taxid.replace(/[^\d]/g, '')
}

export const checkTaxidType = (taxId: string) => {
  if (isCNPJ(taxId)) return 'cnpj'
  if (isCPF(taxId)) return 'cpf'
  return 'unkown'
}

export function isCNPJ(taxid: string): boolean {
  const multipliers = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  const formatedTaxId = taxid.replace(/[^\d]/g, '')

  const cnpjFormatRegex =
    /^(0{14}|1{14}|2{14}|3{14}|4{14}|5{14}|6{14}|7{14}|8{14}|9{14})$/

  if (
    !formatedTaxId ||
    formatedTaxId.length !== 14 ||
    cnpjFormatRegex.test(formatedTaxId)
  )
    return false

  const data: string[] = formatedTaxId.split('')

  let i = 0
  let j = 0

  for (; i < 12; i++) {
    j += +data[i] * multipliers[i + 1]
  }

  j = 11 - (j % 11)
  j = j >= 10 ? 0 : j

  if (+data[12] !== j) return false

  for (i = 0, j = 0; i <= 12; i++) {
    j += +data[i] * multipliers[i]
  }

  j = 11 - (j % 11)
  j = j >= 10 ? 0 : j

  if (+data[13] !== j) return false

  return true
}

export function isCPF(taxId: string): boolean {
  const cpf = taxId.replace(/[^\d]+/g, '')

  const cpfFormatRegex =
    /^(0{11}|1{11}|2{11}|3{11}|4{11}|5{11}|6{11}|7{11}|8{11}|9{11})$/

  if (!cpf || cpf.length !== 11 || cpfFormatRegex.test(cpf)) return false

  function validateDigit(digit: number): boolean {
    let add = 0
    const init = digit - 9

    for (let i = 0; i < 9; i++) {
      add += +cpf.charAt(i + init) * (i + 1)
    }

    return (add % 11) % 10 === +cpf.charAt(digit)
  }

  return validateDigit(9) && validateDigit(10)
}
